import C from "./constants";

export const setExpandedDetails = newDetails => {
  return {
    type: C.SET_EXPANDED_DETAILS,
    payload: newDetails
  };
};